/**
 * Shared UI layout constants.
 *
 * FIELD_WIDTH is the Tailwind width class for form fields and BUTTON_SIZE
 * the pixel size for icon buttons; used across the bounty and submission
 * create/display pages.
 */
export const FIELD_WIDTH = "w-64";
export const BUTTON_SIZE = 25;
